import { useState, useEffect } from 'react';
import API from '../lib/api';

import { useParams } from 'react-router';
import { Grid, GridCol, Container, Center, Paper, Code } from '@mantine/core';
import RecordingSVG from '../components/RecordingSVG';


export function RecordingPage() {
	const { recording_id } = useParams();
	const [r, setR] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchRecording = async () => {
			const r = await API.post('recording/getRecording', { id: recording_id, getTracks: 1 });
			if (r.error) {
				console.error(r.error);
				return;
			}
			setR(r);
			setLoading(false);
		}
		fetchRecording();
	}, []);

	// calculate % of the recording that is music from musicConfidence data - r.musicConfidence
	const calculateMusicPercentage = (recording) => {
		if (!recording || !recording.musicConfidence) return 0;
		const totalDuration = recording.musicConfidence.length;
		const musicDuration = recording.musicConfidence.reduce((acc, val) => acc + (val.confidence > 0.1 ? 1 : 0), 0);
		console.log(`Total Duration: ${totalDuration}, Music Duration: ${musicDuration}`);
		return (musicDuration / totalDuration) * 100;
	};

	
	// If the recording is still loading, say so
	if (loading) {
		return <h1>Loading...</h1>;
	}

	return (
		<>
			<Center>
				<Paper w={1000} shadow="sm" p="md" m="md">
					<Code>{r.filename}</Code><br/>
					{r.musicConfidence && <Code>Music Percentage: {calculateMusicPercentage(r).toFixed(2)}%</Code>}
					{/* <Grid mt="md">
						<GridCol span={6}>
							<h2>Watermark Matches</h2>
							{r.data?.matches && r.data.matches.map((match, i) => (
								<div key={match.start + '-' + match.mark}>
									{match.start} - {match.end}: <Code>{match.track?.raw?.file_id}</Code>
								</div>
							))}
						</GridCol>
						<GridCol span={6}>
							<h2>AFT Matches</h2>
							{r.fingerprints?.fpDetections && r.fingerprints.fpDetections.map((match, i) => (
								<div key={match.start + '-' + match.fileId} style={{ fontWeight: match.both ? 'bold' : 'normal' }}>
									{match.start} - {match.end}: <Code style={{ fontWeight: match.maxHit > 5 ? 'bold' : 'normal' }}>{match.fileId} - {match.maxHit}</Code>
								</div>
							))}
						</GridCol>
					</Grid> */}
					<Container mt="md">
						<RecordingSVG record={r} />
					</Container>
				</Paper>
			</Center>
		</>
	);
}